export default __webpack_public_path__ + "atomic/_patterns/02-molecules/api-retail-finder/_api-retail-finder.twig";